"use strict";

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;
var abstractmessage_1 = require("./abstractmessage");
var Message = /*#__PURE__*/function (_abstractmessage_1$Ab) {
  _inherits(Message, _abstractmessage_1$Ab);
  var _super = _createSuper(Message);
  function Message(grant, contentType, request) {
    var _this;
    _classCallCheck(this, Message);
    _this = _super.call(this);
    _this.method = 'message';
    _this.active_grant = grant;
    _this.payload_type = contentType;
    _this.http_request = request;
    return _this;
  }
  return _createClass(Message);
}(abstractmessage_1.AbstractMessage);
exports.Message = Message;